module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 62);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 1 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(65), __esModule: true };

/***/ }),
/* 3 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(18);
var IE8_DOM_DEFINE = __webpack_require__(45);
var toPrimitive = __webpack_require__(27);
var dP = Object.defineProperty;

exports.f = __webpack_require__(5) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(20)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(69);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(47);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(97);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(101);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(47);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = __webpack_require__(104)(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(107)();
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = require("draft-js");

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var core = __webpack_require__(1);
var ctx = __webpack_require__(44);
var hide = __webpack_require__(14);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(4);
var createDesc = __webpack_require__(23);
module.exports = __webpack_require__(5) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(78);
var defined = __webpack_require__(24);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(26)('wks');
var uid = __webpack_require__(22);
var Symbol = __webpack_require__(0).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _draftJs = __webpack_require__(12);

var _draftToHTML = __webpack_require__(109);

var _draftToHTML2 = _interopRequireDefault(_draftToHTML);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Function returns collection of currently selected blocks.
*/
// @file: util functions file
// @auth: spc@data.me 2017/10/12
function getSelectedBlocksList(editorState) {
    var selectionState = editorState.getSelection();
    var contentState = editorState.getCurrentContent();
    var startKey = selectionState.getStartKey();
    var endKey = selectionState.getEndKey();
    var blockMap = contentState.getBlockMap();
    return blockMap.toSeq().skipUntil(function (_, key) {
        return key === startKey;
    }).takeUntil(function (_, key) {
        return key === endKey;
    }).concat([[endKey, blockMap.get(endKey)]]).toList();
}

/**
* Function returns collection of currently selected blocks.
*/
function getSelectedBlocksMap(editorState) {
    var selectionState = editorState.getSelection();
    var contentState = editorState.getCurrentContent();
    var startKey = selectionState.getStartKey();
    var endKey = selectionState.getEndKey();
    var blockMap = contentState.getBlockMap();
    return blockMap.toSeq().skipUntil(function (_, key) {
        return key === startKey;
    }).takeUntil(function (_, key) {
        return key === endKey;
    }).concat([[endKey, blockMap.get(endKey)]]);
}

/**
* Function will return currently selected text in the editor.
*/
function getSelectionText(editorState) {
    var selectedText = '';
    var selectionState = editorState.getSelection();
    var startKey = selectionState.getAnchorOffset();
    var endKey = selectionState.getFocusOffset();
    var selectedBlocks = getSelectedBlocksList(editorState);
    if (selectedBlocks.size > 0) {
        if (selectionState.getIsBackward()) {
            var tempKey = startKey;
            startKey = endKey;
            endKey = tempKey;
        }
        selectedText = selectedBlocks.map(function (block, index) {
            console.log(block.getText());
            var start = 0;
            var end = block.getText().length;
            if (index === 0) {
                start = startKey;
            }
            if (index === selectedBlocks.size - 1) {
                end = endKey;
            }
            return block.getText().slice(start, end);
        }).join('');
    }
    return selectedText;
}

// /**
// * Function will return inlineStyle of currently selected text in the editor.
// */
// function getSelectedBlocksStyle(editorState) {
//     const inlineStyles = {
//         BOLD: true,
//         ITALIC: true,
//         UNDERLINE: true,
//         STRIKETHROUGH: true,
//         CODE: true,
//         SUPERSCRIPT: true,
//         SUBSCRIPT: true
//     };
//     const currentSelection = editorState.getSelection();
//     const start = currentSelection.getStartOffset();
//     const end = currentSelection.getEndOffset();
//     const selectedBlocks = getSelectedBlocksList(editorState);
//     if (selectedBlocks.size > 0) {
//       for (let i = 0; i < selectedBlocks.size; i += 1) {
//         let blockStart = i === 0 ? start : 0;
//         let blockEnd =
//           i === (selectedBlocks.size - 1) ? end : selectedBlocks.get(i).getText().length;
//         if (blockStart === blockEnd && blockStart === 0) {
//           blockStart = 1;
//           blockEnd = 2;
//         } else if (blockStart === blockEnd) {
//           blockStart -= 1;
//         }
//         for (let j = blockStart; j < blockEnd; j += 1) {
//             const inlineStylesAtOffset = selectedBlocks.get(i).getInlineStyleAt(j);
//                ['BOLD', 'ITALIC', 'UNDERLINE', 'STRIKETHROUGH', 'CODE', 'SUPERSCRIPT', 'SUBSCRIPT'].forEach((style) => {
//                   inlineStyles[style] = inlineStyles[style] && inlineStylesAtOffset.get(style) === style;
//                   });
//             }
//       }
//     }
//     return inlineStyles;
// }

/*
Get currentBlock in the editorState.
*/
function getCurrentBlock(editorState) {
    var selectionState = editorState.getSelection();
    var contentState = editorState.getCurrentContent();
    var block = contentState.getBlockForKey(selectionState.getStartKey());
    return block;
}

/**
* Function will change block level meta-data.
*/
function setBlockData(editorState, data) {
    var newContentState = _draftJs.Modifier.setBlockData(editorState.getCurrentContent(), editorState.getSelection(), data);
    return _draftJs.EditorState.push(editorState, newContentState, 'change-block-data');
}

/**
* Function will render block style by meta-data.
*/
function blockStyleFunc(block) {
    var blockAlignment = block.getData() && block.getData().get('text-align');
    if (blockAlignment) {
        return 'rde-text-align-' + blockAlignment;
    }
    return '';
}

module.exports = {
    stateToHTML: _draftToHTML2.default,
    blockStyleFunc: blockStyleFunc,
    setBlockData: setBlockData,
    getCurrentBlock: getCurrentBlock,
    getSelectionText: getSelectionText
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(19);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 22 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(26)('keys');
var uid = __webpack_require__(22);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(19);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 28 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(18);
var dPs = __webpack_require__(77);
var enumBugKeys = __webpack_require__(33);
var IE_PROTO = __webpack_require__(25)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(46)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(82).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(50);
var enumBugKeys = __webpack_require__(33);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 33 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(4).f;
var has = __webpack_require__(3);
var TAG = __webpack_require__(16)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(16);


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var core = __webpack_require__(1);
var LIBRARY = __webpack_require__(29);
var wksExt = __webpack_require__(35);
var defineProperty = __webpack_require__(4).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 37 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (process.env.NODE_ENV !== 'production') {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IuWbvuWxgl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgODAwIDgwMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgODAwIDgwMDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8Zz4KCTxwYXRoIGQ9Ik0zMjAuMyw0NTUuM2wyMi44LDIyLjhjMC43LDAuNywxLjUsMSwyLjQsMWMwLjgsMCwxLjctMC4zLDIuNC0xbDEyNy45LTEyNy45bDAuMS0wLjFjMS4xLTEuMywxLjEtMy4zLTAuMS00LjYKCQlsLTIyLjgtMjIuOGMtMS4zLTEuMy0zLjQtMS4zLTQuNywwTDMyMC4zLDQ1MC42QzMxOC45LDQ1MiwzMTguOSw0NTQsMzIwLjMsNDU1LjN6Ii8+Cgk8cGF0aCBkPSJNNDA3LjEsNDMyLjhsLTI3LjYsMjcuNWw0LjIsNC4yTDMwNSw1NDMuM2wtNTAuMS01MC4xbDc4LjgtNzguOGw0LjIsNC4ybDI3LjYtMjcuNmwtMjQuMi0yNC4yCgkJYy0yLTItNC43LTMuMS03LjYtMy4xYy0yLjksMC01LjUsMS4xLTcuNiwzLjFMMjA3LjQsNDg1LjZjLTIsMi0zLjEsNC43LTMuMSw3LjZjMCwyLjksMS4xLDUuNSwzLjEsNy42bDkwLDkwYzIsMiw0LjcsMy4xLDcuNiwzLjEKCQljMi45LDAsNS41LTEuMSw3LjYtMy4xbDExOC43LTExOC42YzQuMi00LjIsNC4yLTExLDAtMTUuMUw0MDcuMSw0MzIuOHoiLz4KCTxwYXRoIGQ9Ik01ODguMywzMDAuMWwtOTAtOTBjLTQuMi00LjItMTEtNC4yLTE1LjEsMEwzNjQuNCwzMjguOGMtNC4yLDQuMi00LjIsMTEsMCwxNS4xbDI0LjIsMjQuMmwyNy42LTI3LjZsLTQuMi00LjIKCQlsNzguOC03OC44bDUwLjEsNTAuMUw0NjIsMzg2LjRsLTQuMi00LjJsLTI3LjYsMjcuNmwyNC4yLDI0LjJjMi4xLDIuMSw0LjgsMy4xLDcuNiwzLjFjMi43LDAsNS41LTEsNy42LTMuMWwxMTguNy0xMTguNwoJCWMyLTIsMy4xLTQuNywzLjEtNy42UzU5MC4zLDMwMi4xLDU4OC4zLDMwMC4xeiIvPgo8L2c+Cjwvc3ZnPgo="

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(24);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(3);
var toObject = __webpack_require__(42);
var IE_PROTO = __webpack_require__(25)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(68);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(5) && !__webpack_require__(20)(function () {
  return Object.defineProperty(__webpack_require__(46)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(19);
var document = __webpack_require__(0).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(72);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(87);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(29);
var $export = __webpack_require__(13);
var redefine = __webpack_require__(49);
var hide = __webpack_require__(14);
var has = __webpack_require__(3);
var Iterators = __webpack_require__(30);
var $iterCreate = __webpack_require__(76);
var setToStringTag = __webpack_require__(34);
var getPrototypeOf = __webpack_require__(43);
var ITERATOR = __webpack_require__(16)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(14);


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(3);
var toIObject = __webpack_require__(15);
var arrayIndexOf = __webpack_require__(79)(false);
var IE_PROTO = __webpack_require__(25)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 51 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 52 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(50);
var hiddenKeys = __webpack_require__(33).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(37);
var createDesc = __webpack_require__(23);
var toIObject = __webpack_require__(15);
var toPrimitive = __webpack_require__(27);
var has = __webpack_require__(3);
var IE8_DOM_DEFINE = __webpack_require__(45);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(5) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(38);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (process.env.NODE_ENV !== 'production') {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getBlockTag = getBlockTag;
exports.getBlockStyle = getBlockStyle;
exports.getStylesAtOffset = getStylesAtOffset;
exports.sameStyleAsPrevious = sameStyleAsPrevious;
exports.addInlineStyleMarkup = addInlineStyleMarkup;
exports.addStylePropertyMarkup = addStylePropertyMarkup;
exports.trimLeadingZeros = trimLeadingZeros;
exports.trimTrailingZeros = trimTrailingZeros;
exports.getBlockInnerMarkup = getBlockInnerMarkup;
exports.getBlockMarkup = getBlockMarkup;

var _common = __webpack_require__(110);

/**
* Mapping block-type to corresponding html tag.
*/
var blockTypesMapping = {
    unstyled: 'p',
    'header-one': 'h1',
    'header-two': 'h2',
    'header-three': 'h3',
    'header-four': 'h4',
    'header-five': 'h5',
    'header-six': 'h6',
    'unordered-list-item': 'ul',
    'ordered-list-item': 'ol',
    blockquote: 'blockquote'
};

/**
* Function will return HTML tag for a block.
*/
function getBlockTag(type) {
    return type && blockTypesMapping[type];
}

/**
* Function will return style string for a block.
*/
function getBlockStyle(data) {
    var styles = '';
    (0, _common.forEach)(data, function (key, value) {
        if (value) {
            styles += key + ':' + value + ';';
        }
    });
    return styles;
}

/**
* The function returns an array of entity-sections in blocks.
* These will be areas in block which have same entity or no entity applicable to them.
*/
function getSections(block) {
    var sections = [];
    var lastOffset = 0;
    var sectionRanges = block.entityRanges.map(function (range) {
        var offset = range.offset,
            length = range.length,
            key = range.key;

        return {
            offset: offset,
            length: length,
            key: key,
            type: 'ENTITY'
        };
    });
    sectionRanges = sectionRanges.sort(function (s1, s2) {
        return s1.offset - s2.offset;
    });
    sectionRanges.forEach(function (r) {
        if (r.offset > lastOffset) {
            sections.push({
                start: lastOffset,
                end: r.offset
            });
        }
        sections.push({
            start: r.offset,
            end: r.offset + r.length,
            entityKey: r.key,
            type: r.type
        });
        lastOffset = r.offset + r.length;
    });
    if (lastOffset < block.text.length) {
        sections.push({
            start: lastOffset,
            end: block.text.length
        });
    }
    return sections;
}

/**
* Function to check if the block is an atomic entity block.
*/
function isAtomicEntityBlock(block) {
    if (block.entityRanges.length > 0 && (0, _common.isEmptyString)(block.text) || block.type === 'atomic') {
        return true;
    }
    return false;
}

/**
* The function will return array of inline styles applicable to the block.
*/
function getStyleArrayForBlock(block) {
    var text = block.text,
        inlineStyleRanges = block.inlineStyleRanges;

    var inlineStyles = {
        BOLD: new Array(text.length),
        ITALIC: new Array(text.length),
        UNDERLINE: new Array(text.length),
        STRIKETHROUGH: new Array(text.length),
        CODE: new Array(text.length),
        SUPERSCRIPT: new Array(text.length),
        SUBSCRIPT: new Array(text.length),
        COLOR: new Array(text.length),
        BGCOLOR: new Array(text.length),
        FONTSIZE: new Array(text.length),
        FONTFAMILY: new Array(text.length),
        length: text.length
    };
    if (inlineStyleRanges && inlineStyleRanges.length > 0) {
        inlineStyleRanges.forEach(function (range) {
            var offset = range.offset;

            var length = offset + range.length;
            for (var i = offset; i < length; i += 1) {
                if (range.style.indexOf('color-') === 0) {
                    inlineStyles.COLOR[i] = range.style.substring(6);
                } else if (range.style.indexOf('bgcolor-') === 0) {
                    inlineStyles.BGCOLOR[i] = range.style.substring(8);
                } else if (range.style.indexOf('fontsize-') === 0) {
                    inlineStyles.FONTSIZE[i] = range.style.substring(9);
                } else if (range.style.indexOf('fontfamily-') === 0) {
                    inlineStyles.FONTFAMILY[i] = range.style.substring(11);
                } else if (inlineStyles[range.style]) {
                    inlineStyles[range.style][i] = true;
                }
            }
        });
    }
    return inlineStyles;
}

/**
* The function will return inline style applicable at some offset within a block.
*/
function getStylesAtOffset(inlineStyles, offset) {
    var styles = {};
    if (inlineStyles.COLOR[offset]) {
        styles.COLOR = inlineStyles.COLOR[offset];
    }
    if (inlineStyles.BGCOLOR[offset]) {
        styles.BGCOLOR = inlineStyles.BGCOLOR[offset];
    }
    if (inlineStyles.FONTSIZE[offset]) {
        styles.FONTSIZE = inlineStyles.FONTSIZE[offset];
    }
    if (inlineStyles.FONTFAMILY[offset]) {
        styles.FONTFAMILY = inlineStyles.FONTFAMILY[offset];
    }
    if (inlineStyles.UNDERLINE[offset]) {
        styles.UNDERLINE = true;
    }
    if (inlineStyles.ITALIC[offset]) {
        styles.ITALIC = true;
    }
    if (inlineStyles.BOLD[offset]) {
        styles.BOLD = true;
    }
    if (inlineStyles.STRIKETHROUGH[offset]) {
        styles.STRIKETHROUGH = true;
    }
    if (inlineStyles.CODE[offset]) {
        styles.CODE = true;
    }
    if (inlineStyles.SUBSCRIPT[offset]) {
        styles.SUBSCRIPT = true;
    }
    if (inlineStyles.SUPERSCRIPT[offset]) {
        styles.SUPERSCRIPT = true;
    }
    return styles;
}

/**
* Function returns true for a set of styles if the value of these styles at an offset
* are same as that on the previous offset.
*/
function sameStyleAsPrevious(inlineStyles, styles, index) {
    var sameStyled = true;
    if (index > 0 && index < inlineStyles.length) {
        styles.forEach(function (style) {
            sameStyled = sameStyled && inlineStyles[style][index] === inlineStyles[style][index - 1];
        });
    } else {
        sameStyled = false;
    }
    return sameStyled;
}

/**
* Function returns html for text depending on inline style tags applicable to it.
*/
function addInlineStyleMarkup(style, content) {
    if (style === 'BOLD') {
        return '<strong>' + content + '</strong>';
    } else if (style === 'ITALIC') {
        return '<em>' + content + '</em>';
    } else if (style === 'UNDERLINE') {
        return '<ins>' + content + '</ins>';
    } else if (style === 'STRIKETHROUGH') {
        return '<del>' + content + '</del>';
    } else if (style === 'CODE') {
        return '<code>' + content + '</code>';
    } else if (style === 'SUPERSCRIPT') {
        return '<sup>' + content + '</sup>';
    } else if (style === 'SUBSCRIPT') {
        return '<sub>' + content + '</sub>';
    }
    return content;
}

/**
* The function returns text for given section of block after doing required character replacements.
*/
function getSectionText(text) {
    if (text && text.length > 0) {
        var chars = text.map(function (ch) {
            switch (ch) {
                case '\n':
                    return '<br>\n';
                case '&':
                    return '&amp;';
                case '<':
                    return '&lt;';
                case '>':
                    return '&gt;';
                default:
                    return ch;
            }
        });
        return chars.join('');
    }
    return '';
}

/**
* Function returns html for text depending on inline style tags applicable to it.
*/
function addStylePropertyMarkup(styleSection) {
    var styles = styleSection.styles,
        text = styleSection.text;

    var content = getSectionText(text);
    if (styles && (styles.COLOR || styles.BGCOLOR || styles.FONTSIZE || styles.FONTFAMILY)) {
        var styleString = 'style="';
        if (styles.COLOR) {
            styleString += 'color: ' + styles.COLOR + ';';
        }
        if (styles.BGCOLOR) {
            styleString += 'background-color: ' + styles.BGCOLOR + ';';
        }
        if (styles.FONTSIZE) {
            styleString += 'font-size: ' + styles.FONTSIZE + 'px;';
        }
        if (styles.FONTFAMILY) {
            styleString += 'font-family: ' + styles.FONTFAMILY + ';';
        }
        styleString += '"';
        return '<span ' + styleString + '>' + content + '</span>';
    }
    return content;
}

/**
* Function will return markup for Entity.
*/
function getEntityMarkup(entityMap, entityKey, text, customEntityTransform) {
    var entity = entityMap[entityKey];
    if (typeof customEntityTransform === 'function') {
        var html = customEntityTransform(entity, text);
        if (html) {
            return html;
        }
    }
    if (entity.type === 'MENTION') {
        return '<a href="' + entity.data.url + '" class="wysiwyg-mention" data-mention data-value="' + entity.data.value + '">' + text + '</a>';
    }
    if (entity.type === 'LINK') {
        var target = entity.data.target || '_self';
        return '<a href="' + entity.data.url + '" target="' + target + '" >' + text + '</a>';
    }
    if (entity.type === 'IMAGE') {
        return '<div class="image-container" style="text-align:' + entity.data.alignment + '"><span class="image-wrap"><img src="' + entity.data.src + '" style="max-width:100%"/></span></div>';
    }
    if (entity.type === 'EMBEDDED_LINK') {
        return '<iframe width="' + entity.data.width + '" height="' + entity.data.height + '" src="' + entity.data.src + '" frameBorder="0" allowFullScreen />';
    }
    return text;
}

/**
* For a given section in a block the function will return a further list of sections,
* with similar inline styles applicable to them.
*/
function getInlineStyleSections(block, styles, start, end) {
    var styleSections = [];
    var text = block.text;

    if (text.length > 0) {
        var inlineStyles = getStyleArrayForBlock(block);
        var section = void 0;
        for (var i = start; i < end; i += 1) {
            if (i !== start && sameStyleAsPrevious(inlineStyles, styles, i)) {
                section.text.push(text[i]);
                section.end = i + 1;
            } else {
                section = {
                    styles: getStylesAtOffset(inlineStyles, i),
                    text: [text[i]],
                    start: i,
                    end: i + 1
                };
                styleSections.push(section);
            }
        }
    }
    return styleSections;
}

/**
* Replace leading blank spaces by &nbsp;
*/
function trimLeadingZeros(sectionText) {
    if (sectionText) {
        var replacedText = sectionText;
        for (var i = 0; i < replacedText.length; i += 1) {
            if (sectionText[i] === ' ') {
                replacedText = replacedText.replace(' ', '&nbsp;');
            } else {
                break;
            }
        }
        return replacedText;
    }
    return sectionText;
}

/**
* Replace trailing blank spaces by &nbsp;
*/
function trimTrailingZeros(sectionText) {
    if (sectionText) {
        var replacedText = sectionText;
        for (var i = replacedText.length - 1; i >= 0; i -= 1) {
            if (replacedText[i] === ' ') {
                replacedText = replacedText.substring(0, i) + '&nbsp;' + replacedText.substring(i + 1);
            } else {
                break;
            }
        }
        return replacedText;
    }
    return sectionText;
}

/**
* The method returns markup for section to which inline styles
* like BOLD, ITALIC, UNDERLINE, STRIKETHROUGH, CODE, SUPERSCRIPT, SUBSCRIPT are applicable.
*/
function getStyleTagSectionMarkup(styles, text) {
    var content = text;
    (0, _common.forEach)(styles, function (style, value) {
        content = addInlineStyleMarkup(style, content, value);
    });
    return content;
}

/**
* The method returns markup for section to which inline styles
like color, background-color, font-size are applicable.
*/
function getInlineStyleSectionMarkup(block, styleSection) {
    var stylePropertySections = getInlineStyleSections(block, ['COLOR', 'BGCOLOR', 'FONTSIZE', 'FONTFAMILY'], styleSection.start, styleSection.end);
    var styleSectionText = '';
    stylePropertySections.forEach(function (stylePropertySection) {
        styleSectionText += addStylePropertyMarkup(stylePropertySection);
    });
    styleSectionText = getStyleTagSectionMarkup(styleSection.styles, styleSectionText);
    return styleSectionText;
}

/*
* The method returns markup for an entity section.
* An entity section is a continuous section in a block
* to which same entity or no entity is applicable.
*/
function getSectionMarkup(block, entityMap, section, customEntityTransform) {
    var entityInlineMarkup = [];
    var inlineStyleSections = getInlineStyleSections(block, ['BOLD', 'ITALIC', 'UNDERLINE', 'STRIKETHROUGH', 'CODE', 'SUPERSCRIPT', 'SUBSCRIPT'], section.start, section.end);
    inlineStyleSections.forEach(function (styleSection) {
        entityInlineMarkup.push(getInlineStyleSectionMarkup(block, styleSection));
    });
    var sectionText = entityInlineMarkup.join('');
    if (section.type === 'ENTITY') {
        if (section.entityKey !== undefined && section.entityKey !== null) {
            sectionText = getEntityMarkup(entityMap, section.entityKey, sectionText, customEntityTransform);
        }
    } else if (section.type === 'HASHTAG') {
        sectionText = '<a href="' + sectionText + '" class="wysiwyg-hashtag">' + sectionText + '</a>';
    }
    return sectionText;
}

/**
* Function will return the markup for block preserving the inline styles and
* special characters like newlines or blank spaces.
*/
function getBlockInnerMarkup(block, entityMap, hashtagConfig, customEntityTransform) {
    var blockMarkup = [];
    var sections = getSections(block, hashtagConfig);
    sections.forEach(function (section, index) {
        var sectionText = getSectionMarkup(block, entityMap, section, customEntityTransform);
        if (index === 0) {
            sectionText = trimLeadingZeros(sectionText);
        }
        if (index === sections.length - 1) {
            sectionText = trimTrailingZeros(sectionText);
        }
        blockMarkup.push(sectionText);
    });
    return blockMarkup.join('');
}

/**
* Function will return html for the block.
*/
function getBlockMarkup(block, entityMap, hashtagConfig, directional, customEntityTransform) {
    var blockHtml = [];
    if (isAtomicEntityBlock(block)) {
        blockHtml.push(getEntityMarkup(entityMap, block.entityRanges.length > 0 ? block.entityRanges[0].key : 0, undefined, customEntityTransform));
    } else {
        var blockTag = getBlockTag(block.type);
        if (blockTag) {
            blockHtml.push('<' + blockTag);
            var blockStyle = getBlockStyle(block.data);
            if (blockStyle) {
                blockHtml.push(' style="' + blockStyle + '"');
            }
            if (directional) {
                blockHtml.push(' dir = "auto"');
            }
            blockHtml.push('>');
            blockHtml.push(getBlockInnerMarkup(block, entityMap, hashtagConfig, customEntityTransform));
            blockHtml.push('</' + blockTag + '>');
        }
    }
    blockHtml.push('\n');
    return blockHtml.join('');
}

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IuWbvuWxgl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgODAwIDgwMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgODAwIDgwMDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8cGF0aCBkPSJNNTUwLjEsMjgzSDIyOS45Yy0yLjIsMC0zLjksMS44LTMuOSw0LjJ2MzAuNmMwLDIuMywxLjcsNC4yLDMuOSw0LjJoMTQwLjZ2MzA0LjljMCwyLjMsMS44LDQuMSw0LjIsNC4xaDMwLjYKCWMyLjMsMCw0LjItMS44LDQuMi00LjFWMzIyaDE0MC42YzIuMSwwLDMuOC0xLjksMy45LTQuMnYtMzAuNkM1NTQsMjg0LjksNTUyLjMsMjgzLDU1MC4xLDI4M3oiLz4KPC9zdmc+Cg=="

/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IuWbvuWxgl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgODAwIDgwMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgODAwIDgwMDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8Zz4KCTxwYXRoIGQ9Ik01NDMuNCwyNjNIMjE0LjJjLTEuNiwwLTIuOSwwLjktMi45LDJ2MzVjMCwxLjEsMS4zLDIsMi45LDJoMzI5LjJjMS42LDAsMi45LTAuOSwyLjktMnYtMzUKCQlDNTQ2LjMsMjYzLjksNTQ1LDI2Myw1NDMuNCwyNjN6Ii8+Cgk8cGF0aCBkPSJNNDczLjMsNTE4SDIxNC4yYy0xLjYsMC0yLjksMC45LTIuOSwydjM1YzAsMS4xLDEuMywyLDIuOSwyaDI1OS4xYzEuNiwwLDIuOS0wLjksMi45LTJ2LTM1CgkJQzQ3Ni4yLDUxOC45LDQ3NC45LDUxOCw0NzMuMyw1MTh6Ii8+Cgk8cGF0aCBkPSJNNDAzLjIsMzQ4aC0xODljLTEuNiwwLTIuOSwwLjktMi45LDJ2MzVjMCwxLjEsMS4zLDIsMi45LDJoMTg5YzEuNiwwLDIuOS0wLjksMi45LTJ2LTM1CgkJQzQwNi4xLDM0OC45LDQwNC44LDM0OCw0MDMuMiwzNDh6Ii8+Cgk8cGF0aCBkPSJNNTkzLjUsNDMzSDIxNC4yYy0xLjYsMC0yLjksMC45LTIuOSwydjM1YzAsMS4xLDEuMywyLDIuOSwyaDM3OS4zYzEuNiwwLDIuOS0wLjksMi45LTJ2LTM1CgkJQzU5Ni40LDQzMy45LDU5NS4xLDQzMyw1OTMuNSw0MzN6Ii8+CjwvZz4KPC9zdmc+Cg=="

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IuWbvuWxgl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgODAwIDgwMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgODAwIDgwMDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8Zz4KCTxwYXRoIGQ9Ik01NjguNCwyNjNIMjM5LjJjLTEuNiwwLTIuOSwwLjktMi45LDJ2MzVjMCwxLjEsMS4zLDIsMi45LDJoMzI5LjJjMS42LDAsMi45LTAuOSwyLjktMnYtMzUKCQlDNTcxLjIsMjYzLjksNTY5LjksMjYzLDU2OC40LDI2M3oiLz4KCTxwYXRoIGQ9Ik01MzMuMyw1MThIMjc0LjJjLTEuNiwwLTIuOSwwLjktMi45LDJ2MzVjMCwxLjEsMS4zLDIsMi45LDJoMjU5LjFjMS42LDAsMi45LTAuOSwyLjktMnYtMzUKCQlDNTM2LjIsNTE4LjksNTM0LjksNTE4LDUzMy4zLDUxOHoiLz4KCTxwYXRoIGQ9Ik00OTguMywzNDhoLTE4OWMtMS42LDAtMi45LDAuOS0yLjksMnYzNWMwLDEuMSwxLjMsMiwyLjksMmgxODljMS42LDAsMi45LTAuOSwyLjktMnYtMzUKCQlDNTAxLjEsMzQ4LjksNDk5LjgsMzQ4LDQ5OC4zLDM0OHoiLz4KCTxwYXRoIGQ9Ik01OTMuNCw0MzNIMjE0LjFjLTEuNiwwLTIuOSwwLjktMi45LDJ2MzVjMCwxLjEsMS4zLDIsMi45LDJoMzc5LjNjMS42LDAsMi45LTAuOSwyLjktMnYtMzUKCQlDNTk2LjMsNDMzLjksNTk1LDQzMyw1OTMuNCw0MzN6Ii8+CjwvZz4KPC9zdmc+Cg=="

/***/ }),
/* 61 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IuWbvuWxgl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgODAwIDgwMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgODAwIDgwMDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8Zz4KCTxwYXRoIGQ9Ik01OTMuMSwyNjNIMjYzLjljLTEuNiwwLTIuOSwwLjktMi45LDJ2MzVjMCwxLjEsMS4zLDIsMi45LDJoMzI5LjJjMS42LDAsMi45LTAuOSwyLjktMnYtMzUKCQlDNTk2LDI2My45LDU5NC43LDI2Myw1OTMuMSwyNjN6Ii8+Cgk8cGF0aCBkPSJNNTkzLjEsNTE4SDMzNGMtMS42LDAtMi45LDAuOS0yLjksMnYzNWMwLDEuMSwxLjMsMiwyLjksMmgyNTkuMWMxLjYsMCwyLjktMC45LDIuOS0ydi0zNQoJCUM1OTYsNTE4LjksNTk0LjcsNTE4LDU5My4xLDUxOHoiLz4KCTxwYXRoIGQ9Ik01OTMuMSwzNDhoLTE4OWMtMS42LDAtMi45LDAuOS0yLjksMnYzNWMwLDEuMSwxLjMsMiwyLjksMmgxODljMS42LDAsMi45LTAuOSwyLjktMnYtMzUKCQlDNTk2LDM0OC45LDU5NC43LDM0OCw1OTMuMSwzNDh6Ii8+Cgk8cGF0aCBkPSJNNTkzLjEsNDMzSDIxMy45Yy0xLjYsMC0yLjksMC45LTIuOSwydjM1YzAsMS4xLDEuMywyLDIuOSwyaDM3OS4zYzEuNiwwLDIuOS0wLjksMi45LTJ2LTM1CgkJQzU5Niw0MzMuOSw1OTQuNyw0MzMsNTkzLjEsNDMzeiIvPgo8L2c+Cjwvc3ZnPgo="

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(63);


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Editor = __webpack_require__(64);

var _Editor2 = _interopRequireDefault(_Editor);

var _utils = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
    Editor: _Editor2.default,
    stateToHTML: _utils.stateToHTML
};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; // @file: Editor component jsx file
// @auth: spc@data.me 2017/10/10

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(11);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _draftJs = __webpack_require__(12);

var _ToolBar = __webpack_require__(108);

var _ToolBar2 = _interopRequireDefault(_ToolBar);

var _Link = __webpack_require__(126);

var _Link2 = _interopRequireDefault(_Link);

var _blocks = __webpack_require__(128);

var _blocks2 = _interopRequireDefault(_blocks);

var _utils = __webpack_require__(17);

__webpack_require__(134);

__webpack_require__(135);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DraftEditor = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(DraftEditor, _Component);

    function DraftEditor(props) {
        (0, _classCallCheck3.default)(this, DraftEditor);

        var _this = (0, _possibleConstructorReturn3.default)(this, (DraftEditor.__proto__ || (0, _getPrototypeOf2.default)(DraftEditor)).call(this, props));

        _this.onChange = function (editorState) {
            var onChange = _this.props.onChange;

            if (onChange) {
                onChange((0, _draftJs.convertToRaw)(editorState.getCurrentContent()));
            }
            if ((0, _utils.getCurrentBlock)(editorState).getKey() !== (0, _utils.getCurrentBlock)(_this.state.editorState).getKey()) {
                _this.setState({
                    editorState: _draftJs.EditorState.forceSelection(editorState, editorState.getSelection())
                });
            } else {
                _this.setState({
                    editorState: editorState
                });
            }
        };

        _this.onTab = function (event) {
            var editorState = _draftJs.RichUtils.onTab(event, _this.state.editorState, 4);
            if (editorState) {
                _this.onChange(editorState);
                event.preventDefault();
            }
        };

        _this.getEditorState = function () {
            return _this.state.editorState;
        };

        _this.createEditorState = function () {
            var decorator = new _draftJs.CompositeDecorator([_Link2.default]);
            if (_this.props.initContentState) {
                return _draftJs.EditorState.createWithContent((0, _draftJs.convertFromRaw)(_this.props.initContentState), decorator);
            }
            return _draftJs.EditorState.createEmpty(decorator);
        };

        _this.handleReturn = function (event) {
            var editorState = _this.state.editorState;

            if (!event.altKey && !event.metaKey && !event.ctrlKey) {
                var currentBlock = (0, _utils.getCurrentBlock)(editorState);
                var blockType = currentBlock.getType();
                var blockDepth = currentBlock.getDepth();
                if (blockType === 'atomic') {
                    return 'handled';
                }
                if (currentBlock.getLength() === 0) {
                    switch (blockType) {
                        case 'unordered-list-item':
                        case 'ordered-list-item':
                            if (blockDepth > 0) {
                                var newBlock = currentBlock.set('depth', blockDepth - 1);
                                var contentState = editorState.getCurrentContent();
                                var blockMap = contentState.getBlockMap().set(newBlock.getKey(), newBlock);
                                var selection = editorState.getSelection();
                                var newContentState = contentState.merge({
                                    blockMap: blockMap,
                                    selectionBefore: selection,
                                    selectionAfter: selection
                                });
                                _this.onChange(_draftJs.EditorState.push(editorState, newContentState, 'adjust-depth'));
                            } else {
                                _this.onChange(_draftJs.RichUtils.toggleBlockType(editorState, 'unstyled'));
                            }
                            return 'handled';
                        case 'header-three':
                            _this.onChange(_draftJs.RichUtils.toggleBlockType(editorState, 'unstyled'));
                            return 'handled';
                        default:
                            return 'not-handled';
                    }
                }
                return 'not-handled';
            }
            return 'not-handled';
        };

        _this.handleKeyCommand = function (command, editorState) {
            var newState = _draftJs.RichUtils.handleKeyCommand(editorState, command);
            if (newState) {
                _this.onChange(newState);
                return 'handled';
            }
            var currentBlock = (0, _utils.getCurrentBlock)(editorState);
            var blockType = currentBlock.getType();
            if (blockType === 'atomic') {
                if (command === 'delete' || command === 'backspace') {
                    var contentState = editorState.getCurrentContent();
                    var deletedState = _draftJs.EditorState.push(editorState, _draftJs.Modifier.removeRange(contentState, editorState.getSelection(), 'forward'), 'remove-range');
                    var unstyledState = _draftJs.EditorState.push(deletedState, _draftJs.Modifier.setBlockType(deletedState.getCurrentContent(), editorState.getSelection(), 'unstyled'), 'change-block-type');
                    if (unstyledState) {
                        _this.onChange(unstyledState);
                        return 'handled';
                    }
                }
            }
            return 'not-handled';
        };

        _this.handleBeforeInput = function (chars, editorState) {
            var currentBlock = (0, _utils.getCurrentBlock)(editorState);
            var blockType = currentBlock.getType();
            if (blockType === 'atomic') {
                return 'handled';
            }
            return 'not-handled';
        };

        _this.handlePastedText = function (text, html, editorState) {
            var currentBlock = (0, _utils.getCurrentBlock)(editorState);
            var blockType = currentBlock.getType();
            if (blockType === 'atomic') {
                return 'handled';
            }
            return 'not-handled';
        };

        _this.state = {
            editorState: undefined
        };
        return _this;
    }

    (0, _createClass3.default)(DraftEditor, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var editorState = this.createEditorState();
            this.setState({
                editorState: editorState
            });
        }
        // trigger when editorState change

        // get EditorState

        // create default EditorState

        // change EditorState
        // changeEditorState: Function = (editorState) => {
        //     this.setState({
        //         editorState
        //     });
        // }
        // handle return key

        // key handle

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                placeholder = _props.placeholder,
                readOnly = _props.readOnly;
            var editorState = this.state.editorState;

            return _react2.default.createElement(
                'div',
                { className: 'rde-wrap' },
                !readOnly && _react2.default.createElement(_ToolBar2.default, {
                    currentState: editorState,
                    imageUploader: this.props.imageUploader,
                    changeState: this.onChange,
                    customBlockConfig: this.props.customBlockConfig,
                    ref: function ref(_ref) {
                        _this2.wrapper = _ref;
                    }
                }),
                _react2.default.createElement(_draftJs.Editor, {
                    onTab: this.onTab,
                    blockRendererFn: (0, _blocks2.default)(this.onChange, this.getEditorState, this.props.customBlockConfig, this.props.imageUploader),
                    blockStyleFn: _utils.blockStyleFunc,
                    editorState: editorState,
                    onChange: this.onChange,
                    readOnly: readOnly,
                    handleKeyCommand: this.handleKeyCommand,
                    handleBeforeInput: this.handleBeforeInput,
                    handlePastedText: this.handlePastedText,
                    handleReturn: this.handleReturn,
                    placeholder: placeholder,
                    ref: function ref(_ref2) {
                        _this2.editor = _ref2;
                    }
                })
            );
        }
    }]);
    return DraftEditor;
}(_react.Component), _class.propTypes = {
    imageUploader: _propTypes2.default.func.isRequired,
    initContentState: _propTypes2.default.object,
    customBlockConfig: _propTypes2.default.object,
    readOnly: _propTypes2.default.bool,
    onChange: _propTypes2.default.func,
    placeholder: _propTypes2.default.string
}, _temp);
exports.default = DraftEditor;
module.exports = exports['default'];

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(66);
module.exports = __webpack_require__(1).Object.getPrototypeOf;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(42);
var $getPrototypeOf = __webpack_require__(43);

__webpack_require__(67)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(13);
var core = __webpack_require__(1);
var fails = __webpack_require__(20);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(70), __esModule: true };

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(71);
var $Object = __webpack_require__(1).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(13);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(5), 'Object', { defineProperty: __webpack_require__(4).f });


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(73), __esModule: true };

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74);
__webpack_require__(83);
module.exports = __webpack_require__(35).f('iterator');


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(75)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(48)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(28);
var defined = __webpack_require__(24);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(31);
var descriptor = __webpack_require__(23);
var setToStringTag = __webpack_require__(34);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(14)(IteratorPrototype, __webpack_require__(16)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(4);
var anObject = __webpack_require__(18);
var getKeys = __webpack_require__(32);

module.exports = __webpack_require__(5) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(51);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(15);
var toLength = __webpack_require__(80);
var toAbsoluteIndex = __webpack_require__(81);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(28);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(28);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(0).document;
module.exports = document && document.documentElement;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(84);
var global = __webpack_require__(0);
var hide = __webpack_require__(14);
var Iterators = __webpack_require__(30);
var TO_STRING_TAG = __webpack_require__(16)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(85);
var step = __webpack_require__(86);
var Iterators = __webpack_require__(30);
var toIObject = __webpack_require__(15);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(48)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(88), __esModule: true };

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(89);
__webpack_require__(94);
__webpack_require__(95);
__webpack_require__(96);
module.exports = __webpack_require__(1).Symbol;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(0);
var has = __webpack_require__(3);
var DESCRIPTORS = __webpack_require__(5);
var $export = __webpack_require__(13);
var redefine = __webpack_require__(49);
var META = __webpack_require__(90).KEY;
var $fails = __webpack_require__(20);
var shared = __webpack_require__(26);
var setToStringTag = __webpack_require__(34);
var uid = __webpack_require__(22);
var wks = __webpack_require__(16);
var wksExt = __webpack_require__(35);
var wksDefine = __webpack_require__(36);
var enumKeys = __webpack_require__(91);
var isArray = __webpack_require__(92);
var anObject = __webpack_require__(18);
var toIObject = __webpack_require__(15);
var toPrimitive = __webpack_require__(27);
var createDesc = __webpack_require__(23);
var _create = __webpack_require__(31);
var gOPNExt = __webpack_require__(93);
var $GOPD = __webpack_require__(54);
var $DP = __webpack_require__(4);
var $keys = __webpack_require__(32);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(53).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(37).f = $propertyIsEnumerable;
  __webpack_require__(52).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(29)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    replacer = args[1];
    if (typeof replacer == 'function') $replacer = replacer;
    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
      if ($replacer) value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(14)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(22)('meta');
var isObject = __webpack_require__(19);
var has = __webpack_require__(3);
var setDesc = __webpack_require__(4).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(20)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(32);
var gOPS = __webpack_require__(52);
var pIE = __webpack_require__(37);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(51);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(15);
var gOPN = __webpack_require__(53).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 94 */
/***/ (function(module, exports) {



/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(36)('asyncIterator');


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(36)('observable');


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(98), __esModule: true };

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(99);
module.exports = __webpack_require__(1).Object.setPrototypeOf;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(13);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(100).set });


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(19);
var anObject = __webpack_require__(18);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(44)(Function.call, __webpack_require__(54).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(102), __esModule: true };

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(103);
var $Object = __webpack_require__(1).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(13);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(31) });


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(38);
var invariant = __webpack_require__(39);
var warning = __webpack_require__(55);
var assign = __webpack_require__(105);

var ReactPropTypesSecret = __webpack_require__(40);
var checkPropTypes = __webpack_require__(106);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== 'production') {
  var invariant = __webpack_require__(39);
  var warning = __webpack_require__(55);
  var ReactPropTypesSecret = __webpack_require__(40);
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(38);
var invariant = __webpack_require__(39);
var ReactPropTypesSecret = __webpack_require__(40);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2; // @file: Toolbar component jsx file
// @auth: spc@data.me 2017/10/10

// import unlinkIcon from '../../../../icon/unlink.svg';


var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(11);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(56);

var _classnames2 = _interopRequireDefault(_classnames);

var _draftJs = __webpack_require__(12);

var _utils = __webpack_require__(17);

var _LinkModal = __webpack_require__(112);

var _LinkModal2 = _interopRequireDefault(_LinkModal);

var _CustomModal = __webpack_require__(114);

var _CustomModal2 = _interopRequireDefault(_CustomModal);

var _bold = __webpack_require__(116);

var _bold2 = _interopRequireDefault(_bold);

var _italic = __webpack_require__(117);

var _italic2 = _interopRequireDefault(_italic);

var _underscore = __webpack_require__(118);

var _underscore2 = _interopRequireDefault(_underscore);

var _title = __webpack_require__(119);

var _title2 = _interopRequireDefault(_title);

var _alignLeft = __webpack_require__(59);

var _alignLeft2 = _interopRequireDefault(_alignLeft);

var _alignCenter = __webpack_require__(60);

var _alignCenter2 = _interopRequireDefault(_alignCenter);

var _alignRight = __webpack_require__(61);

var _alignRight2 = _interopRequireDefault(_alignRight);

var _list = __webpack_require__(120);

var _list2 = _interopRequireDefault(_list);

var _orderedList = __webpack_require__(121);

var _orderedList2 = _interopRequireDefault(_orderedList);

var _link = __webpack_require__(41);

var _link2 = _interopRequireDefault(_link);

var _img = __webpack_require__(122);

var _img2 = _interopRequireDefault(_img);

var _clean = __webpack_require__(123);

var _clean2 = _interopRequireDefault(_clean);

var _factube = __webpack_require__(124);

var _factube2 = _interopRequireDefault(_factube);

__webpack_require__(125);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ToolBar = (_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(ToolBar, _Component);

    function ToolBar() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ToolBar);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ToolBar.__proto__ || (0, _getPrototypeOf2.default)(ToolBar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            showLinkModal: false,
            showCustomModal: false,
            currentTextAlignment: undefined,
            currentTextStyle: undefined,
            currentBlockType: undefined
        }, _this.onStyleChange = function (blockStyle) {
            var _this$props = _this.props,
                currentState = _this$props.currentState,
                changeState = _this$props.changeState;

            var newState = _draftJs.RichUtils.toggleInlineStyle(currentState, blockStyle);
            if (newState) {
                changeState(newState);
            }
        }, _this.onTypeChange = function (blockType) {
            var _this$props2 = _this.props,
                currentState = _this$props2.currentState,
                changeState = _this$props2.changeState;

            var newState = _draftJs.RichUtils.toggleBlockType(currentState, blockType);
            if (newState) {
                if (blockType === 'ordered-list-item' || blockType === 'unordered-list-item') {
                    changeState((0, _utils.setBlockData)(newState, { 'text-align': undefined }));
                } else {
                    changeState(newState);
                }
            }
        }, _this.onCleanClick = function () {
            var currentState = _this.props.currentState;

            var contentState = currentState.getCurrentContent();
            ['BOLD', 'ITALIC', 'UNDERLINE', 'STRIKETHROUGH', 'MONOSPACE', 'FONTFAMILY', 'COLOR', 'BGCOLOR', 'FONTSIZE', 'SUPERSCRIPT', 'SUBSCRIPT'].forEach(function (style) {
                contentState = _draftJs.Modifier.removeInlineStyle(contentState, currentState.getSelection(), style);
            });
            var noStyleState = _draftJs.EditorState.push(currentState, contentState, 'change-inline-style');
            var noTypeState = _draftJs.RichUtils.toggleBlockType(noStyleState, 'unstyled');
            _this.props.changeState((0, _utils.setBlockData)(noTypeState, { 'text-align': undefined }));
        }, _this.onImgClick = function () {
            _this.imgInput.value = null;
            _this.imgInput.click();
        }, _this.onImgChange = function (event) {
            var file = event.target.files[0];
            if (file.type.indexOf('image/') === 0) {
                var src = URL.createObjectURL(file);
                var currentState = _this.props.currentState;

                var entityKey = _draftJs.Entity.create('IMAGE', 'MUTABLE', { src: src, alignment: 'center', loading: true });
                var newState = _draftJs.AtomicBlockUtils.insertAtomicBlock(currentState, entityKey, ' ');
                _this.props.changeState(newState);
                _this.props.imageUploader(file).then(function (data) {
                    var contentState = newState.getCurrentContent().replaceEntityData(entityKey, { src: data.src, alignment: 'center' });
                    var newerState = _draftJs.EditorState.push(newState, contentState, 'apply-entity');
                    _this.props.changeState(_draftJs.EditorState.forceSelection(newerState, newerState.getSelection()));
                });
            }
        }, _this.toggleAlignment = function (alignment) {
            var currentState = _this.props.currentState;
            var currentTextAlignment = _this.state.currentTextAlignment;

            if (currentTextAlignment !== alignment) {
                _this.props.changeState((0, _utils.setBlockData)(currentState, { 'text-align': alignment }));
            } else {
                _this.props.changeState((0, _utils.setBlockData)(currentState, { 'text-align': undefined }));
            }
        }, _this.showLinkModal = function () {
            _this.setState({
                showLinkModal: true
            });
        }, _this.hideLinkModal = function () {
            _this.setState({
                showLinkModal: false
            });
        }, _this.submitLink = function (linkTitle, linkTarget) {
            _this.addLink(linkTitle, linkTarget);
            _this.hideLinkModal();
        }, _this.addLink = function (linkTitle, linkTarget) {
            var currentState = _this.props.currentState;
            // const contentState = currentState.getCurrentContent();

            var entityKey = _draftJs.Entity.create('LINK', 'MUTABLE', {
                url: linkTarget
            });
            var newState = _draftJs.RichUtils.toggleLink(currentState, currentState.getSelection(), entityKey);
            var contentState = _draftJs.Modifier.replaceText(newState.getCurrentContent(), newState.getSelection(), '' + linkTitle, newState.getCurrentInlineStyle(), entityKey);
            _this.props.changeState(_draftJs.EditorState.push(newState, contentState, 'insert-characters'));
        }, _this.showCustomModal = function () {
            _this.setState({
                showCustomModal: true
            });
        }, _this.hideCustomModal = function () {
            _this.setState({
                showCustomModal: false
            });
        }, _this.submitCustom = function (customData) {
            _this.addCustom(customData);
            _this.hideCustomModal();
        }, _this.addCustom = function (customData) {
            if (customData) {
                var currentState = _this.props.currentState;

                var entityKey = _draftJs.Entity.create('CUSTOM', 'INMUTABLE', { customData: customData });
                _this.props.changeState(_draftJs.AtomicBlockUtils.insertAtomicBlock(currentState, entityKey, ' '));
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(ToolBar, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(props) {
            if (props.currentState !== this.props.currentState) {
                this.setState({
                    currentTextAlignment: (0, _utils.getCurrentBlock)(props.currentState).getData().get('text-align'),
                    currentTextStyle: props.currentState.getCurrentInlineStyle(),
                    currentBlockType: _draftJs.RichUtils.getCurrentBlockType(props.currentState)
                });
            }
        }
        // clear all style, metas, special types

        // add new image

        // upload image

        // change alignment data

        // show add link modal

        // hide add link modal

        // call on link request submitted

        // add a new link

        // show add Custom modal

        // hide add Custom modal

        // call on link request submitted

        // add a new Custom

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'rde-toolbar' },
                _react2.default.createElement(
                    'button',
                    {
                        className: (0, _classnames2.default)('rde-toolbar-button', { 'rde-toolbar-button-on': this.state.currentTextStyle && this.state.currentTextStyle.has('BOLD') }),
                        title: '\u52A0\u7C97',
                        onClick: function onClick() {
                            return _this2.onStyleChange('BOLD');
                        },
                        disabled: this.state.currentBlockType === 'atomic'
                    },
                    _react2.default.createElement('img', { src: _bold2.default, alt: 'Bold' })
                ),
                _react2.default.createElement(
                    'button',
                    {
                        className: (0, _classnames2.default)('rde-toolbar-button', { 'rde-toolbar-button-on': this.state.currentTextStyle && this.state.currentTextStyle.has('ITALIC') }),
                        title: '\u659C\u4F53',
                        onClick: function onClick() {
                            return _this2.onStyleChange('ITALIC');
                        },
                        disabled: this.state.currentBlockType === 'atomic'
                    },
                    _react2.default.createElement('img', { src: _italic2.default, alt: 'Italic' })
                ),
                _react2.default.createElement(
                    'button',
                    {
                        className: (0, _classnames2.default)('rde-toolbar-button', { 'rde-toolbar-button-on': this.state.currentTextStyle && this.state.currentTextStyle.has('UNDERLINE') }),
                        title: '\u4E0B\u5212\u7EBF',
                        onClick: function onClick() {
                            return _this2.onStyleChange('UNDERLINE');
                        },
                        disabled: this.state.currentBlockType === 'atomic'
                    },
                    _react2.default.createElement('img', { src: _underscore2.default, alt: 'UNDERLINE' })
                ),
                _react2.default.createElement(
                    'button',
                    {
                        className: (0, _classnames2.default)('rde-toolbar-button', { 'rde-toolbar-button-on': this.state.currentBlockType === 'header-three' }),
                        title: '\u6807\u9898',
                        onClick: function onClick() {
                            return _this2.onTypeChange('header-three');
                        },
                        disabled: this.state.currentBlockType === 'atomic'
                    },
                    _react2.default.createElement('img', { src: _title2.default, alt: 'Title' })
                ),
                _react2.default.createElement(
                    'button',
                    {
                        className: (0, _classnames2.default)('rde-toolbar-button', { 'rde-toolbar-button-on': this.state.currentTextAlignment === 'left' }),
                        title: '\u5DE6\u5BF9\u9F50',
                        onClick: function onClick() {
                            return _this2.toggleAlignment('left');
                        },
                        disabled: this.state.currentBlockType === 'atomic' || this.state.currentBlockType === 'ordered-list-item' || this.state.currentBlockType === 'unordered-list-item'
                    },
                    _react2.default.createElement('img', { src: _alignLeft2.default, alt: 'Left' })
                ),
                _react2.default.createElement(
                    'button',
                    {
                        className: (0, _classnames2.default)('rde-toolbar-button', { 'rde-toolbar-button-on': this.state.currentTextAlignment === 'center' }),
                        title: '\u5C45\u4E2D',
                        onClick: function onClick() {
                            return _this2.toggleAlignment('center');
                        },
                        disabled: this.state.currentBlockType === 'atomic' || this.state.currentBlockType === 'ordered-list-item' || this.state.currentBlockType === 'unordered-list-item'
                    },
                    _react2.default.createElement('img', { src: _alignCenter2.default, alt: 'Center' })
                ),
                _react2.default.createElement(
                    'button',
                    {
                        className: (0, _classnames2.default)('rde-toolbar-button', { 'rde-toolbar-button-on': this.state.currentTextAlignment === 'right' }),
                        title: '\u53F3\u5BF9\u9F50',
                        onClick: function onClick() {
                            return _this2.toggleAlignment('right');
                        },
                        disabled: this.state.currentBlockType === 'atomic' || this.state.currentBlockType === 'ordered-list-item' || this.state.currentBlockType === 'unordered-list-item'
                    },
                    _react2.default.createElement('img', { src: _alignRight2.default, alt: 'Right' })
                ),
                _react2.default.createElement(
                    'button',
                    {
                        className: (0, _classnames2.default)('rde-toolbar-button', { 'rde-toolbar-button-on': this.state.currentBlockType === 'unordered-list-item' }),
                        title: '\u9879\u76EE\u7B26\u53F7',
                        onClick: function onClick() {
                            return _this2.onTypeChange('unordered-list-item');
                        },
                        disabled: this.state.currentBlockType === 'atomic'
                    },
                    _react2.default.createElement('img', { src: _list2.default, alt: 'List' })
                ),
                _react2.default.createElement(
                    'button',
                    {
                        className: (0, _classnames2.default)('rde-toolbar-button', { 'rde-toolbar-button-on': this.state.currentBlockType === 'ordered-list-item' }),
                        title: '\u5217\u8868',
                        onClick: function onClick() {
                            return _this2.onTypeChange('ordered-list-item');
                        },
                        disabled: this.state.currentBlockType === 'atomic'
                    },
                    _react2.default.createElement('img', { src: _orderedList2.default, alt: 'Order List' })
                ),
                _react2.default.createElement(
                    'button',
                    {
                        className: 'rde-toolbar-button',
                        title: '\u63D2\u5165\u8D85\u94FE\u63A5',
                        onClick: this.showLinkModal,
                        disabled: this.state.currentBlockType === 'atomic'
                    },
                    _react2.default.createElement('img', { src: _link2.default, alt: 'Link' })
                ),
                _react2.default.createElement(
                    'button',
                    {
                        className: 'rde-toolbar-button',
                        title: '\u63D2\u5165\u56FE\u7247',
                        onClick: this.onImgClick,
                        disabled: this.state.currentBlockType === 'atomic' || this.state.currentBlockType === 'ordered-list-item' || this.state.currentBlockType === 'unordered-list-item'
                    },
                    _react2.default.createElement('img', { src: _img2.default, alt: 'Insert Pic' }),
                    _react2.default.createElement('input', {
                        type: 'file',
                        accept: 'image/jpg,image/png,image/gif,image/jpeg',
                        ref: function ref(_ref2) {
                            _this2.imgInput = _ref2;
                        },
                        onChange: this.onImgChange,
                        style: { display: 'none' }
                    })
                ),
                this.props.customBlockConfig && _react2.default.createElement(
                    'button',
                    {
                        className: 'rde-toolbar-button',
                        title: this.props.customBlockConfig.customTitle,
                        onClick: this.showCustomModal,
                        disabled: this.state.currentBlockType === 'atomic' || this.state.currentBlockType === 'ordered-list-item' || this.state.currentBlockType === 'unordered-list-item'
                    },
                    _react2.default.createElement('img', { src: _factube2.default, alt: 'Insert Custom Content' })
                ),
                _react2.default.createElement(
                    'button',
                    { className: 'rde-toolbar-button', title: '\u6E05\u9664\u6837\u5F0F', disabled: this.state.currentBlockType === 'atomic', onClick: this.onCleanClick },
                    _react2.default.createElement('img', { src: _clean2.default, alt: 'Clean' })
                ),
                this.state.showLinkModal && _react2.default.createElement(_LinkModal2.default, {
                    currentState: this.props.currentState,
                    onCancel: this.hideLinkModal,
                    onSubmit: this.submitLink
                }),
                this.props.customBlockConfig && this.state.showCustomModal && _react2.default.createElement(_CustomModal2.default, {
                    customBlockConfig: this.props.customBlockConfig,
                    onCancel: this.hideCustomModal,
                    onSubmit: this.submitCustom
                })
            );
        }
    }]);
    return ToolBar;
}(_react.Component), _class.propTypes = {
    currentState: _propTypes2.default.object.isRequired,
    changeState: _propTypes2.default.func.isRequired,
    imageUploader: _propTypes2.default.func.isRequired,
    customBlockConfig: _propTypes2.default.object
}, _temp2);
exports.default = ToolBar;
module.exports = exports['default'];

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = stateToHtml;

var _block = __webpack_require__(57);

var _list = __webpack_require__(111);

/**
* The function will generate html markup for given draftjs editorContent.
*/
// function transfrom state to hmtl
function stateToHtml(editorContent, hashtagConfig, directional, customEntityTransform) {
    var html = [];
    if (editorContent) {
        var blocks = editorContent.blocks,
            entityMap = editorContent.entityMap;

        if (blocks && blocks.length > 0) {
            var listBlocks = [];
            blocks.forEach(function (block) {
                if ((0, _list.isList)(block.type)) {
                    listBlocks.push(block);
                } else {
                    if (listBlocks.length > 0) {
                        var listHtml = (0, _list.getListMarkup)(listBlocks, entityMap, hashtagConfig, customEntityTransform);
                        html.push(listHtml);
                        listBlocks = [];
                    }
                    var blockHtml = (0, _block.getBlockMarkup)(block, entityMap, {}, directional, customEntityTransform);
                    html.push(blockHtml);
                }
            });
            if (listBlocks.length > 0) {
                var listHtml = (0, _list.getListMarkup)(listBlocks, entityMap, hashtagConfig, customEntityTransform);
                html.push(listHtml);
                listBlocks = [];
            }
        }
    }
    return html.join('');
}
module.exports = exports['default'];

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.forEach = forEach;
exports.isEmptyString = isEmptyString;
/**
* Utility function to execute callback for eack key->value pair.
*/
function forEach(obj, callback) {
    if (obj) {
        for (var key in obj) {
            // eslint-disable-line no-restricted-syntax
            if ({}.hasOwnProperty.call(obj, key)) {
                callback(key, obj[key]);
            }
        }
    }
}

/**
* The function returns true if the string passed to it has no content.
*/
function isEmptyString(str) {
    if (str === undefined || str === null || str.length === 0 || str.trim().length === 0) {
        return true;
    }
    return false;
}

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isList = isList;
exports.getListMarkup = getListMarkup;

var _block = __webpack_require__(57);

/**
* Function to check if a block is of type list.
*/
function isList(blockType) {
    return blockType === 'unordered-list-item' || blockType === 'ordered-list-item';
}

/**
* Function will return html markup for a list block.
*/
function getListMarkup(listBlocks, entityMap, hashtagConfig, directional, customEntityTransform) {
    var listHtml = [];
    var nestedListBlock = [];
    var previousBlock = void 0;
    listBlocks.forEach(function (block) {
        var nestedBlock = false;
        if (!previousBlock) {
            listHtml.push('<' + (0, _block.getBlockTag)(block.type) + '>\n');
        } else if (previousBlock.type !== block.type) {
            listHtml.push('</' + (0, _block.getBlockTag)(previousBlock.type) + '>\n');
            listHtml.push('<' + (0, _block.getBlockTag)(block.type) + '>\n');
        } else if (previousBlock.depth === block.depth) {
            if (nestedListBlock && nestedListBlock.length > 0) {
                listHtml.push(getListMarkup(nestedListBlock, entityMap, hashtagConfig, directional, customEntityTransform));
                nestedListBlock = [];
            }
        } else {
            nestedBlock = true;
            nestedListBlock.push(block);
        }
        if (!nestedBlock) {
            listHtml.push('<li');
            var blockStyle = (0, _block.getBlockStyle)(block.data);
            if (blockStyle) {
                listHtml.push(' style="' + blockStyle + '"');
            }
            if (directional) {
                listHtml.push(' dir = "auto"');
            }
            listHtml.push('>');
            listHtml.push((0, _block.getBlockInnerMarkup)(block, entityMap, hashtagConfig, customEntityTransform));
            listHtml.push('</li>\n');
            previousBlock = block;
        }
    });
    if (nestedListBlock && nestedListBlock.length > 0) {
        listHtml.push(getListMarkup(nestedListBlock, entityMap, hashtagConfig, directional, customEntityTransform));
    }
    listHtml.push('</' + (0, _block.getBlockTag)(previousBlock.type) + '>\n');
    return listHtml.join('');
}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; // @file: Link insert modal jsx file
// @auth: spc@data.me 2017/10/11

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(11);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(17);

__webpack_require__(113);

var _link = __webpack_require__(41);

var _link2 = _interopRequireDefault(_link);

var _text = __webpack_require__(58);

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LinkModal = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(LinkModal, _Component);

    function LinkModal(props) {
        (0, _classCallCheck3.default)(this, LinkModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (LinkModal.__proto__ || (0, _getPrototypeOf2.default)(LinkModal)).call(this, props));

        _this.addLink = function () {
            var _this$state = _this.state,
                linkTitle = _this$state.linkTitle,
                linkTarget = _this$state.linkTarget;

            if (linkTitle === '') {
                _this.props.onSubmit(linkTarget, linkTarget);
            } else {
                _this.props.onSubmit(linkTitle, linkTarget);
            }
        };

        _this.updateLinkTitle = function (event) {
            _this.setState({
                linkTitle: event.target.value
            });
        };

        _this.updateLinkTarget = function (event) {
            _this.setState({
                linkTarget: event.target.value
            });
        };

        _this.state = {
            linkTitle: '',
            linkTarget: ''
        };
        return _this;
    }

    (0, _createClass3.default)(LinkModal, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            if (this.props.currentState) {
                this.setState({
                    linkTitle: (0, _utils.getSelectionText)(this.props.currentState)
                });
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.state.linkTitle === '') {
                this.titleRef.focus();
            } else {
                this.linkRef.focus();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'rde-modal' },
                _react2.default.createElement(
                    'div',
                    { className: 'rde-modal-body' },
                    _react2.default.createElement(
                        'div',
                        { className: 'rde-modal-title' },
                        '\u63D2\u5165\u94FE\u63A5'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'rde-modal-input-box' },
                        _react2.default.createElement('img', { src: _text2.default, alt: '' }),
                        _react2.default.createElement('input', {
                            className: 'rde-modal-input',
                            onChange: this.updateLinkTitle,
                            onBlur: this.updateLinkTitle,
                            value: this.state.linkTitle,
                            ref: function ref(_ref) {
                                _this2.titleRef = _ref;
                            },
                            placeholder: '\u8F93\u5165\u94FE\u63A5\u6587\u672C'
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'rde-modal-input-box' },
                        _react2.default.createElement('img', { src: _link2.default, alt: '' }),
                        _react2.default.createElement('input', {
                            className: 'rde-modal-input',
                            onChange: this.updateLinkTarget,
                            onBlur: this.updateLinkTarget,
                            value: this.state.linkTarget,
                            ref: function ref(_ref2) {
                                _this2.linkRef = _ref2;
                            },
                            placeholder: '\u8F93\u5165\u94FE\u63A5\u5730\u5740'
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'rde-modal-btns' },
                        _react2.default.createElement(
                            'button',
                            { className: 'rde-modal-btn-ok', disabled: this.state.linkTarget === '', onClick: this.addLink },
                            '\u786E\u5B9A'
                        ),
                        _react2.default.createElement(
                            'button',
                            { className: 'rde-modal-btn-cancel', onClick: this.props.onCancel },
                            '\u53D6\u6D88'
                        )
                    )
                )
            );
        }
    }]);
    return LinkModal;
}(_react.Component), _class.propTypes = {
    currentState: _propTypes2.default.object.isRequired,
    onSubmit: _propTypes2.default.func,
    onCancel: _propTypes2.default.func
}, _temp);
exports.default = LinkModal;
module.exports = exports['default'];

/***/ }),
/* 113 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; // @file: Custom insert modal jsx file
// @auth: spc@data.me 2017/10/16

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(11);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _text = __webpack_require__(58);

var _text2 = _interopRequireDefault(_text);

var _styles = __webpack_require__(115);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-unused-vars

var CustomModal = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(CustomModal, _Component);

    function CustomModal(props) {
        (0, _classCallCheck3.default)(this, CustomModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CustomModal.__proto__ || (0, _getPrototypeOf2.default)(CustomModal)).call(this, props));

        _this.onSearch = function () {
            var keyword = _this.state.keyword;

            if (keyword.length > 0) {
                _this.props.customBlockConfig.suggestCustomData(keyword).then(function (values) {
                    _this.setState({
                        data: values
                    });
                });
            }
        };

        _this.addCustom = function (data) {
            _this.props.onSubmit(data);
            _this.props.onCancel();
        };

        _this.updateKeyword = function (event) {
            _this.setState({
                keyword: event.target.value
            });
        };

        _this.handleKeyDown = function (event) {
            if (event.keyCode === 13) {
                _this.onSearch();
                event.stopPropagation();
            }
        };

        _this.state = {
            keyword: '',
            data: undefined
        };
        return _this;
    }

    (0, _createClass3.default)(CustomModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.keyRef.focus();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var config = this.props.customBlockConfig;
            return _react2.default.createElement(
                'div',
                { className: 'rde-modal' },
                _react2.default.createElement(
                    'div',
                    { className: 'rde-modal-body' },
                    _react2.default.createElement(
                        'div',
                        { className: 'rde-modal-title' },
                        config.customTitle
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'rde-modal-input-box' },
                        _react2.default.createElement('img', { src: _text2.default, alt: '' }),
                        _react2.default.createElement('input', {
                            className: 'rde-modal-input',
                            onChange: this.updateKeyword,
                            onKeyDown: this.handleKeyDown,
                            value: this.state.keyword,
                            ref: function ref(_ref) {
                                _this2.keyRef = _ref;
                            },
                            placeholder: '\u8F93\u5165\u5173\u952E\u5B57\u641C\u7D22...'
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'rde-model-selector' },
                        this.state.data && this.state.data.map(function (value) {
                            var card = _react2.default.createElement(
                                'div',
                                { className: 'rde-model-select-item', onClick: function onClick() {
                                        return _this2.addCustom(value);
                                    }, key: value.key, role: 'presentation' },
                                config.renderCustomData(value)
                            );
                            return card;
                        }),
                        this.state.data && this.state.data.length === 0 && _react2.default.createElement(
                            'div',
                            null,
                            '\u5BF9\u4E0D\u8D77\uFF0C\u6CA1\u6709\u627E\u5230\u7ED3\u679C'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'rde-modal-btns' },
                        _react2.default.createElement(
                            'button',
                            { className: 'rde-modal-btn-ok', onClick: this.onSearch },
                            '\u641C\u7D22'
                        ),
                        _react2.default.createElement(
                            'button',
                            { className: 'rde-modal-btn-cancel', onClick: this.props.onCancel },
                            '\u53D6\u6D88'
                        )
                    )
                )
            );
        }
    }]);
    return CustomModal;
}(_react.Component), _class.propTypes = {
    customBlockConfig: _propTypes2.default.object.isRequired,
    onSubmit: _propTypes2.default.func,
    onCancel: _propTypes2.default.func
}, _temp);
exports.default = CustomModal;
module.exports = exports['default'];

/***/ }),
/* 115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 116 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IuWbvuWxgl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgODAwIDgwMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgODAwIDgwMDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8cGF0aCBkPSJNNTQ4LjgsNDA4LjljLTEwLTE0LjQtMjMuNS0yNi4xLTM5LjEtMzMuOWMxMC4yLTE1LjYsMTUuNS0zMy43LDE1LjUtNTIuNWMwLTUzLjItNDMuMy05Ni41LTk2LjUtOTYuNUgzMDkuMwoJYy03LjEsMC0xMi44LDUuNy0xMi44LDEyLjh2MzIyLjRjMCw3LjEsNS43LDEyLjgsMTIuOCwxMi44aDE1My4yYzU3LjksMCwxMDUtNDcuMiwxMDUtMTA1LjFDNTY3LjUsNDQ3LjMsNTYxLDQyNi41LDU0OC44LDQwOC45egoJIE01MTIuMyw0NjkuM2MtMC4yLDI3LjItMjMsNDkuNC01MC42LDQ5LjRoLTExMFY0MTloMTEwLjdjMTMuNCwwLDI1LjksNS4zLDM1LjQsMTQuOUM1MDcuMyw0NDMuNCw1MTIuNCw0NTYsNTEyLjMsNDY5LjN6CgkgTTM1MS43LDM2My44di04Mi43aDc2LjJjMjIuOSwwLDQxLjgsMTguMiw0Mi4yLDQwLjdjMC4yLDExLjItNC4xLDIxLjctMTIsMjkuN2MtNy45LDgtMTguNCwxMi40LTI5LjQsMTIuNEgzNTEuN3oiLz4KPC9zdmc+Cg=="

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IuWbvuWxgl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgODAwIDgwMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgODAwIDgwMDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8cGF0aCBkPSJNNTE0LjcsMjI1LjhIMzU3LjNjLTIuNCwwLTQuMywxLjktNC4zLDQuM3YzMS4xYzAsMi40LDEuOSw0LjMsNC4zLDQuM2g1Ny44bC03MS43LDI2Ny42aC01OC42CgljLTIuNCwwLTQuMywxLjktNC4zLDQuM3YzMS4xYzAsMi40LDEuOSw0LjMsNC4zLDQuM2gxNTYuNWMyLjQsMCw0LjMtMS45LDQuMy00LjN2LTMxLjFjMC0yLjQtMS45LTQuMy00LjMtNC4zaC01Ni45bDcxLjctMjY3LjYKCWg1OC42YzIuNCwwLDQuMy0xLjksNC4zLTQuM1YyMzBDNTE5LDIyNy43LDUxNy4xLDIyNS44LDUxNC43LDIyNS44eiIvPgo8L3N2Zz4K"

/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IuWbvuWxgl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgODAwIDgwMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgODAwIDgwMDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8Zz4KCTxwYXRoIGQ9Ik0zODkuOSw1MTguMWgxOC40YzMzLjQsMCw2NC41LTE0LjgsODcuNi00MS42YzIyLjUtMjYsMzUtNjAuNCwzNS05Ni44VjIxMC41YzAtMi40LTEuOS00LjMtNC4zLTQuM2gtMzEKCQljLTIuNCwwLTQuMywxLjktNC4zLDQuM3YxNjkuMmMwLDU0LjUtMzcuMyw5OC45LTgzLDk4LjloLTE4LjRjLTQ1LjcsMC04My00NC40LTgzLTk4LjlWMjEwLjRjMC0yLjQtMS45LTQuMy00LjMtNC4zaC0zMQoJCWMtMi40LDAtNC4zLDEuOS00LjMsNC4zdjE2OS4zYzAsMzYuNCwxMi41LDcwLjgsMzUsOTYuOEMzMjUuNSw1MDMuMiwzNTYuNiw1MTguMSwzODkuOSw1MTguMXoiLz4KCTxwYXRoIGQ9Ik01MjcuOSw1NTIuOUgyNzAuM2MtMi40LDAtNC4zLDEuOS00LjMsNC4zdjMxLjFjMCwyLjQsMS45LDQuMyw0LjMsNC4zaDI1Ny42YzIuNCwwLDQuMy0xLjksNC4zLTQuM3YtMzEuMQoJCUM1MzIuMSw1NTQuOCw1MzAuMiw1NTIuOSw1MjcuOSw1NTIuOXoiLz4KPC9nPgo8L3N2Zz4K"

/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IuWbvuWxgl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgODAwIDgwMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgODAwIDgwMDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8cGF0aCBkPSJNNTMwLjcsMjI1LjVoLTM1Yy0xLjEsMC0yLDAuOS0yLDJWMzgwSDMwNS4zVjIyNy41YzAtMS4xLTAuOS0yLTItMmgtMzVjLTEuMSwwLTIsMC45LTIsMlYzODJ2MzV2MTU0LjUKCWMwLDEuMSwwLjksMiwyLDJoMzVjMS4xLDAsMi0wLjksMi0yVjQxOWgxODguNHYxNTIuNWMwLDEuMSwwLjksMiwyLDJoMzVjMS4xLDAsMi0wLjksMi0ydi0zNDRDNTMyLjcsMjI2LjQsNTMxLjgsMjI1LjUsNTMwLjcsMjI1LjUKCXoiLz4KPC9zdmc+Cg=="

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IuWbvuWxgl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgODAwIDgwMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgODAwIDgwMDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsOiNFQTE1MTU7fQo8L3N0eWxlPgo8cGF0aCBkPSJNNjI3LDI0MC41SDM2NWMtMS4xLDAtMiwwLjktMiwydjM1YzAsMS4xLDAuOSwyLDIsMmgyNjJjMS4xLDAsMi0wLjksMi0ydi0zNUM2MjksMjQxLjQsNjI4LjEsMjQwLjUsNjI3LDI0MC41egoJIi8+CjxwYXRoIGQ9Ik02MjcsMzY4LjVIMzY1Yy0xLjEsMC0yLDAuOS0yLDJ2MzVjMCwxLjEsMC45LDIsMiwyaDI2MmMxLjEsMCwyLTAuOSwyLTJ2LTM1QzYyOSwzNjkuNCw2MjguMSwzNjguNSw2MjcsMzY4LjV6CgkiLz4KPHBhdGggZD0iTTYyNyw0OTUuNUgzNjVjLTEuMSwwLTIsMC45LTIsMnYzNWMwLDEuMSwwLjksMiwyLDJoMjYyYzEuMSwwLDItMC45LDItMnYtMzVDNjI5LDQ5Ni40LDYyOC4xLDQ5NS41LDYyNyw0OTUuNXoKCSIvPgo8Y2lyY2xlIGN4PSIyNzMiIGN5PSIyNjAuMiIgcj0iNDAiLz4KPGNpcmNsZSBjeD0iMjczIiBjeT0iMzkwLjIiIHI9IjQwIi8+CjxjaXJjbGUgY3g9IjI3MyIgY3k9IjUyMC4yIiByPSI0MCIvPgo8L3N2Zz4K"

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IuWbvuWxgl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgODAwIDgwMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgODAwIDgwMDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8cGF0aCBkPSJNNTkwLjQsMjYwLjdoLTM4MWMtMS4xLDAtMiwwLjktMiwydjI5MGMwLDEuMSwwLjksMiwyLDJoMzgxYzEuMSwwLDItMC45LDItMnYtMjkwCglDNTkyLjQsMjYxLjYsNTkxLjUsMjYwLjcsNTkwLjQsMjYwLjd6IE01NTMuNCwyOTkuN3Y4MC41bC01NS44LTIxLjdjLTguMS0zLjItMTcuMi0xLjEtMjMuMyw1LjFMNDEzLjIsNDI3bC01NC0yNy4yCgljLTcuOC0zLjktMTctMi44LTIzLjYsMi45bC04OS4yLDc2LjRWMjk5LjdINTUzLjR6IE0yNjMuNiw1MTUuN2w4OC41LTc1LjhsNTUuMSwyNy43YzguNSw0LjMsMTguNiwyLjUsMjUuMS00LjNsNjItNjQuM2w1OSwyM3Y5My43CglIMjYzLjZ6Ii8+Cjwvc3ZnPgo="

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IuWbvuWxgl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgODAwIDgwMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgODAwIDgwMDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8cGF0aCBkPSJNNTg1LjQsNTQ4LjhIMzg0LjlsNzguNy03OC43bDAsMGwxMjAuOS0xMjAuOWMzLjItMy4yLDMuOC04LjEsMS43LTExLjljLTAuNC0wLjgtMS0xLjUtMS43LTIuMkw0NjMuNiwyMTQuMgoJbDAsMGwwLDBjLTAuMy0wLjMtMC42LTAuNi0xLTAuOGMtMy40LTIuNi04LjEtMi44LTExLjYtMC40Yy0wLjYsMC40LTEuMSwwLjgtMS42LDEuM2wtNzkuOSw3OS45bC00MSw0MWwwLDBMMjEzLjcsNDUwCgljLTMuOSwzLjktMy45LDEwLjIsMCwxNC4xbDg0LjgsODQuOGgtNDkuMmMtMS4xLDAtMiwwLjktMiwydjM0LjljMCwxLjEsMC45LDIsMiwyaDMzNmMxLjEsMCwyLTAuOSwyLTJ2LTM1CglDNTg3LjQsNTQ5LjcsNTg2LjUsNTQ4LjgsNTg1LjQsNTQ4Ljh6IE0zNDkuMSwzNjkuN2w3OS45LDc5LjlsLTg3LjIsODcuMmwtNzkuOS03OS45TDM0OS4xLDM2OS43eiIvPgo8L3N2Zz4K"

/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IuWbvuWxgl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgODAwIDgwMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgODAwIDgwMDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8cGF0aCBkPSJNNTU2LjIsMjIxLjhoLTMxNGMtMS43LDAtMywxLjMtMywzdjM1MGMwLDEuNywxLjMsMywzLDNoMzE0YzEuNywwLDMtMS4zLDMtM3YtMzUwCglDNTU5LjIsMjIzLjEsNTU3LjgsMjIxLjgsNTU2LjIsMjIxLjh6IE01MjEuMiw1MzkuOGgtMjQ0di0yODBoMjQ0VjUzOS44eiIvPgo8cGF0aCBkPSJNNDYyLjksMzAyLjhIMzM1LjRjLTIuMiwwLTQsMS44LTQsNHYxODZjMCwyLjIsMS44LDQsNCw0aDI5LjhjMi4yLDAsNC0xLjgsNC00VjQxNWg4MC41YzIuMiwwLDQtMS44LDQtNHYtMjcuMgoJYzAtMi4yLTEuOC00LTQtNGgtODAuNVYzMzhoOTMuNmMyLjIsMCw0LTEuOCw0LTR2LTI3LjJDNDY2LjksMzA0LjYsNDY1LjEsMzAyLjgsNDYyLjksMzAyLjh6Ii8+Cjwvc3ZnPgo="

/***/ }),
/* 125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(11);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _draftJs = __webpack_require__(12);

__webpack_require__(127);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function findLinkEntities(contentBlock, callback) {
    contentBlock.findEntityRanges(function (character) {
        var entityKey = character.getEntity();
        return entityKey !== null && _draftJs.Entity.get(entityKey).getType() === 'LINK';
    }, callback);
}

var Link = (_temp = _class = function (_PureComponent) {
    (0, _inherits3.default)(Link, _PureComponent);

    function Link() {
        (0, _classCallCheck3.default)(this, Link);
        return (0, _possibleConstructorReturn3.default)(this, (Link.__proto__ || (0, _getPrototypeOf2.default)(Link)).apply(this, arguments));
    }

    (0, _createClass3.default)(Link, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                entityKey = _props.entityKey;

            var _Entity$get$getData = _draftJs.Entity.get(entityKey).getData(),
                url = _Entity$get$getData.url;

            return _react2.default.createElement(
                'span',
                { className: 'rde-link-decorator' },
                _react2.default.createElement(
                    'a',
                    { href: url, title: url },
                    children
                )
            );
        }
    }]);
    return Link;
}(_react.PureComponent), _class.propTypes = {
    entityKey: _propTypes2.default.string.isRequired,
    children: _propTypes2.default.array
}, _temp);
exports.default = {
    strategy: findLinkEntities,
    component: Link
};
module.exports = exports['default'];

/***/ }),
/* 127 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = blockRendererFunc;

var _draftJs = __webpack_require__(12);

var _Image = __webpack_require__(129);

var _Image2 = _interopRequireDefault(_Image);

var _Custom = __webpack_require__(132);

var _Custom2 = _interopRequireDefault(_Custom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function blockRendererFunc(setEditorState, getEditorState, customBlockConfig, imageUploader) {
    return function (block) {
        if (block.getType() === 'atomic') {
            var entityKey = block.getEntityAt(0);
            if (entityKey) {
                var entity = _draftJs.Entity.get(entityKey);
                if (entity && entity.type === 'IMAGE') {
                    return {
                        component: _Image2.default,
                        editable: false,
                        props: {
                            setEditorState: setEditorState,
                            getEditorState: getEditorState,
                            imageUploader: imageUploader
                        }
                    };
                }
                if (entity && entity.type === 'CUSTOM') {
                    return {
                        component: _Custom2.default,
                        editable: false,
                        props: {
                            setEditorState: setEditorState,
                            getEditorState: getEditorState,
                            customBlockConfig: customBlockConfig
                        }
                    };
                }
            }
        }
        return undefined;
    };
} // @file: Custom Block Func file
// @auth: spc@data.me 2017/10/10
// @modified: spc@data.me 2017/10/16
module.exports = exports['default'];

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _draftJs = __webpack_require__(12);

var _propTypes = __webpack_require__(11);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(17);

var _alignLeft = __webpack_require__(59);

var _alignLeft2 = _interopRequireDefault(_alignLeft);

var _alignCenter = __webpack_require__(60);

var _alignCenter2 = _interopRequireDefault(_alignCenter);

var _alignRight = __webpack_require__(61);

var _alignRight2 = _interopRequireDefault(_alignRight);

var _undo = __webpack_require__(130);

var _undo2 = _interopRequireDefault(_undo);

var _styles = __webpack_require__(131);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-unused-vars

var Image = (_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(Image, _Component);

    function Image() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Image);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Image.__proto__ || (0, _getPrototypeOf2.default)(Image)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            hovered: false,
            isSelected: false,
            reloading: false
        }, _this.onImgChange = function (event) {
            var file = event.target.files[0];
            if (file.type.indexOf('image/') === 0) {
                var src = URL.createObjectURL(file);
                var block = _this.props.block;

                var entityKey = block.getEntityAt(0);
                _draftJs.Entity.mergeData(entityKey, { src: src });
                _this.setState({
                    reloading: true
                });
                _this.props.blockProps.imageUploader(file).then(function (data) {
                    var editorState = _this.props.blockProps.getEditorState();
                    var contentState = editorState.getCurrentContent().mergeEntityData(entityKey, { src: data.src });
                    var newerState = _draftJs.EditorState.push(editorState, contentState, 'apply-entity');
                    _this.setState({
                        reloading: false
                    });
                    _this.props.blockProps.setEditorState(_draftJs.EditorState.forceSelection(newerState, newerState.getSelection()));
                });
            }
        }, _this.setEntityAlignment = function (alignment) {
            var block = _this.props.block;

            var entityKey = block.getEntityAt(0);
            _draftJs.Entity.mergeData(entityKey, { alignment: alignment });
            _this.setState({
                hovered: true
            });
        }, _this.setEntityAlignmentLeft = function () {
            _this.setEntityAlignment('left');
        }, _this.setEntityAlignmentRight = function () {
            _this.setEntityAlignment('right');
        }, _this.setEntityAlignmentCenter = function () {
            _this.setEntityAlignment('center');
        }, _this.focusBlock = function () {
            var _this$props = _this.props,
                block = _this$props.block,
                blockProps = _this$props.blockProps;
            var getEditorState = blockProps.getEditorState,
                setEditorState = blockProps.setEditorState;

            var key = block.getKey();
            var editorState = getEditorState();
            var currentblock = (0, _utils.getCurrentBlock)(editorState);
            if (currentblock.getKey() === key) {
                return;
            }
            var newSelection = new _draftJs.SelectionState({
                anchorKey: key,
                focusKey: key,
                anchorOffset: 0,
                focusOffset: 1
            });
            setEditorState(_draftJs.EditorState.forceSelection(editorState, newSelection));
        }, _this.reloadImg = function () {
            _this.imgReloader.value = null;
            _this.imgReloader.click();
        }, _this.toggleEnter = function () {
            _this.setState({
                hovered: true
            });
        }, _this.toggleLeave = function () {
            _this.setState({
                hovered: false
            });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(Image, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(props) {
            var block = props.block,
                blockProps = props.blockProps;
            var getEditorState = blockProps.getEditorState;

            var key = block.getKey();
            var editorState = getEditorState();
            var currentblock = (0, _utils.getCurrentBlock)(editorState);
            this.setState({
                isSelected: currentblock.getKey() === key
            });
        }
        // upload image

        // 图片获取焦点

        // add new image

    }, {
        key: 'renderAlignmentOptions',
        value: function renderAlignmentOptions() {
            return _react2.default.createElement(
                'div',
                { className: 'rde-image-toolbar' },
                _react2.default.createElement(
                    'button',
                    { className: 'rde-block-button', onClick: this.setEntityAlignmentLeft },
                    _react2.default.createElement('img', { src: _alignLeft2.default, alt: 'Left' })
                ),
                _react2.default.createElement(
                    'button',
                    { className: 'rde-block-button', onClick: this.setEntityAlignmentCenter },
                    _react2.default.createElement('img', { src: _alignCenter2.default, alt: 'Center' })
                ),
                _react2.default.createElement(
                    'button',
                    { className: 'rde-block-button', onClick: this.setEntityAlignmentRight },
                    _react2.default.createElement('img', { src: _alignRight2.default, alt: 'Right' })
                ),
                _react2.default.createElement(
                    'button',
                    { className: 'rde-block-button', onClick: this.reloadImg },
                    _react2.default.createElement('img', { src: _undo2.default, alt: 'ReloadImage' })
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                block = _props.block,
                contentState = _props.contentState;

            var entityKey = block.getEntityAt(0);
            var blockData = {
                src: '',
                alignment: undefined
            };
            if (entityKey) {
                var entity = contentState.getEntity(entityKey);
                blockData = entity.getData();
            }
            var _blockData = blockData,
                src = _blockData.src,
                alignment = _blockData.alignment,
                loading = _blockData.loading;
            // const { hovered } = this.state;

            return _react2.default.createElement(
                'div',
                {
                    className: alignment ? 'rde-image-' + alignment : 'rde-image-center',
                    onClick: this.focusBlock,
                    role: 'presentation'
                },
                _react2.default.createElement(
                    'div',
                    {
                        onMouseEnter: this.toggleEnter,
                        onMouseLeave: this.toggleLeave,
                        className: 'rde-image-wrapper'
                    },
                    (loading || this.state.reloading) && _react2.default.createElement(
                        'div',
                        { className: 'rde-image-loader' },
                        _react2.default.createElement(
                            'div',
                            { className: 'spinner' },
                            _react2.default.createElement('div', { className: 'double-bounce1' }),
                            _react2.default.createElement('div', { className: 'double-bounce2' })
                        )
                    ),
                    _react2.default.createElement('img', {
                        className: 'rde-image-content' + (this.state.isSelected ? ' rde-image-is-selected' : ''),
                        alt: '',
                        src: src
                    }),
                    this.state.hovered && !loading && this.renderAlignmentOptions(),
                    _react2.default.createElement('input', {
                        type: 'file',
                        accept: 'image/jpg,image/png,image/gif,image/jpeg',
                        ref: function ref(_ref2) {
                            _this2.imgReloader = _ref2;
                        },
                        onChange: this.onImgChange,
                        style: { display: 'none' }
                    })
                )
            );
        }
    }]);
    return Image;
}(_react.Component), _class.propTypes = {
    block: _propTypes2.default.object,
    contentState: _propTypes2.default.object,
    blockProps: _propTypes2.default.object
}, _temp2);
exports.default = Image;
module.exports = exports['default'];

/***/ }),
/* 130 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 131 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__(10);

var _react2 = _interopRequireDefault(_react);

var _draftJs = __webpack_require__(12);

var _classnames = __webpack_require__(56);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(11);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(17);

var _link = __webpack_require__(41);

var _link2 = _interopRequireDefault(_link);

var _styles = __webpack_require__(133);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-unused-vars


var Image = (_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(Image, _Component);

    function Image() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Image);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Image.__proto__ || (0, _getPrototypeOf2.default)(Image)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isSelected: false,
            hovered: false
        }, _this.focusBlock = function () {
            var _this$props = _this.props,
                block = _this$props.block,
                blockProps = _this$props.blockProps;
            var getEditorState = blockProps.getEditorState,
                setEditorState = blockProps.setEditorState;

            var key = block.getKey();
            var editorState = getEditorState();
            var newSelection = new _draftJs.SelectionState({
                anchorKey: key,
                focusKey: key,
                anchorOffset: 0,
                focusOffset: 1
            });
            setEditorState(_draftJs.EditorState.forceSelection(editorState, newSelection));
        }, _this.toggleEnter = function () {
            _this.setState({
                hovered: true
            });
        }, _this.toggleLeave = function () {
            _this.setState({
                hovered: false
            });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(Image, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(props) {
            var block = props.block,
                blockProps = props.blockProps;
            var getEditorState = blockProps.getEditorState;

            var key = block.getKey();
            var editorState = getEditorState();
            var currentblock = (0, _utils.getCurrentBlock)(editorState);
            this.setState({
                isSelected: currentblock.getKey() === key
            });
        }
        // 组件获取焦点

    }, {
        key: 'renderLinkOption',
        value: function renderLinkOption(customData) {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'rde-custom-toolbar' },
                _react2.default.createElement(
                    'button',
                    { className: 'rde-block-button', title: '\u67E5\u770B\u539F\u6587', onClick: function onClick() {
                            return _this2.props.blockProps.customBlockConfig.goLink(customData);
                        } },
                    _react2.default.createElement('img', { src: _link2.default, alt: 'Left' })
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                block = _props.block,
                contentState = _props.contentState;

            var entityKey = block.getEntityAt(0);
            var blockData = {
                customData: undefined
            };
            if (entityKey) {
                var entity = contentState.getEntity(entityKey);
                blockData = entity.getData();
            }
            var _blockData = blockData,
                customData = _blockData.customData;

            return _react2.default.createElement(
                'div',
                {
                    className: 'rde-custom-block',
                    onClick: this.focusBlock,
                    onMouseEnter: this.toggleEnter,
                    onMouseLeave: this.toggleLeave,
                    role: 'presentation'
                },
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)('rde-custom-wrapper', { 'rde-custom-is-selected': this.state.isSelected })
                    },
                    this.props.blockProps.customBlockConfig.renderCustomBlock(customData),
                    this.state.hovered && this.renderLinkOption(customData)
                )
            );
        }
    }]);
    return Image;
}(_react.Component), _class.propTypes = {
    block: _propTypes2.default.object,
    contentState: _propTypes2.default.object,
    blockProps: _propTypes2.default.object
}, _temp2);
exports.default = Image;
module.exports = exports['default'];

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// react-draft-editor-ch.js